module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1CvMm4C/media/FC-9781398497108.jpg?1708093998687",
      "alt": "This image is the cover for the book Nurturing"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Nurturing\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Even if it seems on the surface that you have it all figured out, do you still feel empty inside? Have you ever wondered how you can have a long-lasting and meaningful impact in the world instead of just trying to stay afloat in a sea of ever-changing demands? You are not alone. Nurturing offers an easy, fast, and structured overview of how you can take care of yourself and contribute to the world in your own fulfilling way. With practical tips that can be swiftly moved into action at the end of each chapter, it marks the beginning of an exciting and rewarding life changing transformation.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Violet Lentz\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Violet Lentz is a South-Korea-born, Singapore-raised, US-educated Swiss citizen. Her career in the financial and management consulting industries spans across Asia and Europe, dedicating over 24 years of time at MSCI, Merrill Lynch, Credit Suisse, Julius Baer and McKinsey. Currently, she focuses on nurturing herself, visionary companies and inspiring people. She is the co-founder and CEO of Nurturing, a company dedicated to creating a world where everyone feels loved, and nurtures one’s full potential to live a fulfilling life. She serves on the advisory board of Marmot Finance, a Swiss independent asset management firm focusing on women; and as an ambassador for Smiling Gecko, a Swiss charity organisation for Cambodians in need. She is also a certified life coach, meditation instructor, hypnotherapist and healer. She lives in Freienbach, Switzerland, with her husband, Alain Lentz.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0